// index.js

import React from 'react';
import "./global.css";

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // ✅ Move BrowserRouter here
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter> {/* ✅ Correct location */}
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </BrowserRouter>
);
